// extracted by mini-css-extract-plugin
module.exports = {"root":"navigation-list_root__qBO7O"};